import "./TermsAndConditions.scss";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";

const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <div className="tac">
      <div className="wrapper">
        <Container maxWidth="md">
          <Typography variant="h4" gutterBottom>
            Terms and Conditions for bima essentials
          </Typography>
          <Typography variant="h6" gutterBottom>
            Effective Date: 18th April 2025
          </Typography>

          <Typography variant="body1" paragraph>
            These Terms and Conditions ("Terms") govern your access to and use of the bima essentials
            software-as-a-service (SaaS) platform ("Platform"). By accessing or using the Platform,
            you agree to be bound by these Terms.
          </Typography>

          <Typography variant="h6" gutterBottom>1. Acceptance of Terms</Typography>
          <Typography variant="body1" paragraph>
            By subscribing to a plan and using the bima essentials Platform, you acknowledge that you
            have read, understood, and agree to be bound by these Terms and Conditions. You agree that
            this is a legally binding agreement between you ("Client") and ICON Limited ("Provider").
          </Typography>

          <Typography variant="h6" gutterBottom>2. Service Provision</Typography>
          <Typography variant="body1" paragraph>
            ICON Limited grants the Client a non-exclusive, non-transferable right to use 
            Bima essentials for their internal business operations, contingent upon the timely payment of all
            applicable subscription fees.
          </Typography>

          <Typography variant="h6" gutterBottom>3. Data Ownership and Privacy</Typography>
          <Typography variant="body1" paragraph>
            The Client retains all ownership rights to any data, information, or material uploaded or
            entered into the Platform ("Client Data"). Bima essentials will not use, disclose, or
            access Client Data except as required to provide the services, offer support, or as
            legally mandated.
          </Typography>

          <Typography variant="h6" gutterBottom>4. Data Security</Typography>
          <Typography variant="body1" paragraph>
            Bima essentials has implemented industry-standard technical and organizational measures to
            safeguard Client Data against accidental or unlawful destruction, loss, alteration,
            unauthorized disclosure, or access. All data is securely stored and encrypted to ensure
            confidentiality and integrity.
          </Typography>

          <Typography variant="h6" gutterBottom>5. Client Obligations</Typography>
          <Typography variant="body1" paragraph>
            The Client is responsible for the accuracy, quality, and legality of their data and the
            means by which they acquired it. The Client is also responsible for maintaining the
            confidentiality of their account information and passwords.
          </Typography>

          <Typography variant="h6" gutterBottom>6. Payment and Subscription</Typography>
          <Typography variant="body1" paragraph>
            The Client will have access to the Platform upon payment of the selected subscription plan
            fees. Subscription fees are billed in advance on a recurring basis as per the chosen plan.
            Failure to pay fees may result in the suspension or termination of access to the Platform.
          </Typography>

          <Typography variant="h6" gutterBottom>7. Intellectual Property</Typography>
          <Typography variant="body1" paragraph>
            All intellectual property rights in the Platform and its underlying software, including any
            updates, enhancements, and new features, are the exclusive property of ICON Limited.
          </Typography>

          <Typography variant="h6" gutterBottom>8. Confidentiality</Typography>
          <Typography variant="body1" paragraph>
            Both parties agree to maintain the confidentiality of any proprietary or sensitive
            information shared during the course of this agreement. This includes, but is not limited
            to, trade secrets, business plans, and Client Data. This information will not be disclosed
            to any third party without prior written consent, unless required by law.
          </Typography>

          <Typography variant="h6" gutterBottom>9. Disclaimer for Insurance Intermediary</Typography>
          <Typography variant="body1" paragraph>
            Bima essentials is a technology platform for insurance intermediaries and is not an
            insurance provider. The platform facilitates the management of insurance-related data, but
            bima essentials does not offer, sell, or solicit any insurance products. All
            insurance-related activities and decisions are the sole responsibility of the Client. Bima
            essentials is not liable for any actions or omissions of the Client in their capacity as
            an insurance intermediary.
          </Typography>

          <Typography variant="h6" gutterBottom>10. Limitation of Liability</Typography>
          <Typography variant="body1" paragraph>
            In no event shall bima essentials be liable for any indirect, incidental, special, or
            consequential damages arising out of or in connection with the use of the Platform. This
            includes, but is not limited to, loss of profits, data, or business interruption.
          </Typography>

          <Typography variant="h6" gutterBottom>11. Termination</Typography>
          <Typography variant="body1" paragraph>
            Either party may terminate this agreement with written notice. Upon termination, the
            Client's right to access the Platform will cease, and bima essentials will make the
            Client's data available for export for a limited period.
          </Typography>

          <Typography variant="h6" gutterBottom>12. Governing Law</Typography>
          <Typography variant="body1" paragraph>
            These Terms and any disputes arising out of or related to them will be governed by and
            construed in accordance with the laws of The Republic of Kenya.
          </Typography>

          <Typography variant="h6" gutterBottom>13. Changes to Terms</Typography>
          <Typography variant="body1" paragraph>
            ICON Limited reserves the right to modify these Terms at any time. Any changes will be
            effective immediately upon posting the revised Terms on the Platform. Your continued use
            of the Platform after the changes have been posted constitutes your acceptance of the new
            Terms.
          </Typography>

          <Typography variant="h6" gutterBottom>14. Service Availability and Support</Typography>
          <Typography variant="body1" paragraph>
            ICON Limited will use reasonable efforts to ensure that the Platform is available
            24/7, except during scheduled maintenance, emergency maintenance, or circumstances beyond
            the Provider’s reasonable control. Support services, response times, and availability may
            be defined in a separate Service Level Agreement (SLA).
          </Typography>

          <Typography variant="h6" gutterBottom>15. Acceptable Use</Typography>
          <Typography variant="body1" paragraph>
            The Client agrees not to (a) use the Platform for unlawful purposes, (b) attempt to gain
            unauthorized access to the Platform, (c) reverse engineer, decompile, or copy the
            Platform’s code, or (d) upload malicious code or content that may harm the Platform or
            other users.
          </Typography>

          <Typography variant="h6" gutterBottom>16. Indemnification</Typography>
          <Typography variant="body1" paragraph>
            The Client agrees to indemnify and hold harmless ICON Limited, its affiliates, and
            employees from and against any claims, liabilities, damages, or expenses (including
            reasonable legal fees) arising out of the Client’s use of the Platform, violation of these
            Terms, or breach of applicable laws and regulations.
          </Typography>

          <Typography variant="h6" gutterBottom>17. Force Majeure</Typography>
          <Typography variant="body1" paragraph>
            Neither party will be liable for delays or failure to perform obligations (other than
            payment) if such failure results from events beyond their reasonable control, including
            but not limited to natural disasters, government restrictions, labor disputes, or internet
            outages.
          </Typography>

          <Typography variant="h6" gutterBottom>18. Data Retention and Deletion</Typography>
          <Typography variant="body1" paragraph>
            Upon termination of the agreement, Client Data will be retained for 30 days to allow
            export, after which it will be permanently deleted from the Platform, unless required by
            law to be retained longer.
          </Typography>

          <Typography variant="h6" gutterBottom>19. Dispute Resolution</Typography>
          <Typography variant="body1" paragraph>
            Any disputes arising out of these Terms shall first be resolved through good faith
            negotiations. If unresolved, the dispute shall be submitted to binding arbitration in
            Nairobi, Kenya, in accordance with the rules of the Chartered Institute of Arbitrators
            (Kenya Branch).
          </Typography>

          <Typography variant="h6" gutterBottom>20. Entire Agreement</Typography>
          <Typography variant="body1" paragraph>
            These Terms constitute the entire agreement between the parties regarding the Platform and
            supersede all prior agreements, representations, or understandings, whether written or
            oral.
          </Typography>
          <span className="signup-span" onClick={() => navigate("/bima")}>Home</span>
        </Container>
      </div>
    </div>
  );
};

export default TermsAndConditions;
